import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    parameter: {
        width: 250,
        "& span": {
            fontFamily: "Roboto",
            fontSize: 14,
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    parameter__space: {
        borderBottom: "1px solid transparent",
        lineHeight: "19px",
    }
}))
